import { VoiceMessageModel } from "@jugl-web/rest-api";
import { apiUTCToLocalDateTime } from "@jugl-web/utils";
import { isSameDay } from "date-fns";
import React, { useMemo } from "react";
import { VoiceConversationMediaPlayer } from "../../../VoiceConversationSummary/components/VoiceConversationMediaPlayer";
import { VoiceConversationSummaryCard } from "../../../VoiceConversationSummary/components/VoiceConversationSummaryCard";
import { VoiceConversationSummaryPayload } from "../../../VoiceConversationSummary/types";
import { VoiceMessageBubble } from "../VoiceMessageBubble";
import { CRMInfoMessage } from "../CRMInfoMessage";

export const VoiceMessageItem: React.FC<{
  message: VoiceMessageModel;
  messages: VoiceMessageModel[];
}> = ({ message, messages }) => {
  const groupInfo = useMemo(() => {
    const idx = messages.findIndex((item) => item.msg_id === message.msg_id);

    const result = {
      isFirst: false,
      isLast: false,
    };
    const prevMessage = messages[idx - 1];
    const nextMessage = messages[idx + 1];
    if (
      !prevMessage ||
      prevMessage?.from !== message.from ||
      prevMessage?.type === "info" ||
      prevMessage?.auto_response !== message.auto_response ||
      !isSameDay(
        apiUTCToLocalDateTime(prevMessage.payload.timestamp),
        apiUTCToLocalDateTime(message.payload.timestamp)
      )
    ) {
      result.isFirst = true;
    }
    if (
      !nextMessage ||
      nextMessage?.from !== message.from ||
      nextMessage?.type === "info" ||
      nextMessage.auto_response !== message.auto_response
    ) {
      result.isLast = true;
    }

    return result;
  }, [message, messages]);

  const $content = useMemo(() => {
    if (message.type === "info" && message.status === "summary") {
      let payload: VoiceConversationSummaryPayload;

      try {
        payload = JSON.parse(message.payload.text);
      } catch {
        return null;
      }

      const hasMedia = Boolean(payload.media_id);
      const hasSummary = Boolean(payload.topic && payload.summary);

      if (!hasMedia && !hasSummary) {
        return null;
      }

      return (
        <div className="mx-auto my-4 flex w-full max-w-132.5 flex-col gap-4">
          {payload.media_id && (
            <VoiceConversationMediaPlayer
              mediaId={payload.media_id}
              className="border-0 border-l-3 border-solid border-[#E8E2F8]"
            />
          )}
          {hasSummary && (
            <VoiceConversationSummaryCard
              topic={payload.topic}
              summary={payload.summary}
            />
          )}
        </div>
      );
    }

    if (message.type === "info") {
      return (
        <CRMInfoMessage
          message={message.payload.text}
          timestamp={message.payload.timestamp}
        />
      );
    }

    return <VoiceMessageBubble message={message} groupInfo={groupInfo} />;
  }, [groupInfo, message]);

  return $content;
};
